import {Paper, Stack, Typography} from "@mui/material";
import {MaterialSymbol} from "react-material-symbols";

type MessageVariantOneProps = {
  title: string;
  subtitle: string;
  image: {
    url: string;
    alt: string;
    styles: {
      transform: string;
    };
  };
  onClick: () => void;
};
export default function MessageVariantOne(props: MessageVariantOneProps) {
  return (
    <Paper
      onClick={() => props.onClick}
      variant="feature"
      sx={{
        height: "90px",
        px: "16px",
        bgcolor: "#EBEEDD",
        overflow: "hidden",
        ":hover": {cursor: "pointer"},
        position: "relative",
      }}>
      <img
        src={props.image.url}
        alt={props.image.alt}
        style={{
          ...props.image.styles,
          position: "absolute",
          right: "0",
          width: "auto",
          height: "100px",
          opacity: "0.5",
        }}
      />
      <Stack
        direction="column"
        spacing="4px"
        justifyContent={"center"}
        position={"absolute"}
        height={"100%"}>
        <Stack direction="row" spacing="8px">
          <MaterialSymbol
            icon="directions_alt"
            weight={300}
            size={24}
            color="black"
            fill={true}
          />
          <Typography
            component="p"
            variant="body1"
            fontWeight={800}
            color="black"
            sx={{
              letterSpacing: "0.01em",
              textOverflow: "ellipsis",
            }}>
            {props.title}
          </Typography>
        </Stack>
        <Typography
          component="p"
          variant="caption"
          fontWeight="400"
          color="black"
          lineHeight={1.33}
          sx={{
            whiteSpace: "pre-line",
            color: "primary.contrastText",
          }}>
          {props.subtitle}
        </Typography>
      </Stack>
    </Paper>
  );
}
